"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionButton = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var globalSlice_1 = require("../../../../features/global/globalSlice");
var dateHelper_1 = require("../../../../helpers/dateHelper");
var ExpirationPeriodCount_1 = require("../ExpirationPeriodCount");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var SubscriptionButton = function (_a) {
    var extendedClassNames = _a.extendedClassNames, subscriptionPlanLoading = _a.subscriptionPlanLoading, subscriptionPlanName = _a.subscriptionPlanName, subscriptionBtnIcon = _a.subscriptionBtnIcon, subscriptionPlanEnd = _a.subscriptionPlanEnd, addSubscription = _a.addSubscription;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var expirationPeriod = dateHelper_1.getExpirationPeriod(subscriptionPlanEnd);
    var resolveExtendedStyles = function () {
        var extendedStyles = [];
        if (extendedClassNames.length) {
            extendedStyles = extendedClassNames.map(function (className) { return styles_module_scss_1.default[className]; });
        }
        return extendedStyles;
    };
    var handleClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (expirationPeriod) {
            dispatch(globalSlice_1.addToastMessage({
                text: t('SUBSCRIPTION_BUTTON.TOAST_MESSAGES.REQUEST_ERROR'),
                appearance: 'error',
            }));
            return;
        }
        addSubscription(subscriptionPlanName);
    };
    return (react_1.default.createElement("button", { className: classnames_1.default(styles_module_scss_1.default.subscription_btn, resolveExtendedStyles()), disabled: subscriptionPlanLoading, onClick: handleClick },
        react_1.default.createElement("img", { src: subscriptionBtnIcon, alt: "" }),
        react_1.default.createElement("span", null, t("POST_CARD." + subscriptionPlanName.toUpperCase())),
        expirationPeriod && (react_1.default.createElement(ExpirationPeriodCount_1.ExpirationPeriodCount, { expirationPeriod: expirationPeriod }))));
};
exports.SubscriptionButton = SubscriptionButton;
